import { apiFetch } from '@/lib/api';
import { newestFirst } from '@/lib/sort';
import type { Localized } from '@/lib/localized';

// Public "Basında Biz" içerikleri (yalnızca yayında — /api/public/press).
export type PressItem = {
  _id: string;
  title: Localized;
  description: Localized;
  date?: string;
  images?: string[];
  links?: string[];
  createdAt?: string;
  updatedAt?: string;
};

export function listPress() {
  return apiFetch<{ records: PressItem[] }>('/api/public/press').then((r) => ({
    ...r,
    records: newestFirst(r.records),
  }));
}

export function getPress(id: string) {
  return apiFetch<{ record: PressItem }>(`/api/public/press/${id}`);
}
